export const CartActionTypes = {
  SET_ITEM_TO_CART: "SET_ITEM_TO_CART",
  REMOVE_ITEM_FROM_CART: "REMOVE_ITEM_FROM_CART",
  DISABLE_ITEM_FROM_CART: "DISABLE_ITEM_FROM_CART",
  EMPTY_CART: "EMPTY_CART",
};
